const DEVELOPMENT_URL = "http://192.168.1.114:4580";
const PRODUCTION_URL = "/";

// export const DEFAULT_URL = DEVELOPMENT_URL;
export const DEFAULT_URL = PRODUCTION_URL;
